import { observable, runInAction, action } from 'mobx';
import { get, jsonPost } from '../../utils/fetch';
import { backendServer, backendServerInvestor, CLIENT_ID, userServer } from '../../variable';
import { errorHandler } from '../../utils/methods';
import { getSessionStorage, SESSION_NAME, setSessionStorage } from '../../utils/storage';

class UserStore {
  @observable
  userInfo = {
    username: getSessionStorage(SESSION_NAME.username) || ''
  };

  @action
  reset() {
    this.userInfo = {
      username: ''
    }
  }

  // 查询用户业务信息
  fetchUserInfo = async () => {
    let result;
    try {
      result = await get(`${backendServer}/user`);
      runInAction(() => {
        if (result.success && result.data) {
          this.userInfo = result.data;
          setSessionStorage(SESSION_NAME.role, result.data.authorization);
        }
      });
    } catch (err) {
      return errorHandler(err, '查询用户信息');
    }

    return result;
  };

  /**
   * 获取用户基本信息(认证中心)
   */
  getAuthUserInfo = async () => {
    const url = `${userServer}/resource/rs/getUserInfo`;
    try {
      const response = await get(url, {
        requestClientId: CLIENT_ID,
      });
      runInAction(() => {
        if (response.success) {
          this.userInfo = { username: response.result.userBasicInfo.username || '' };
          setSessionStorage(SESSION_NAME.username, response.result.userBasicInfo.username || '');
        }
      });

      console.log('方法getAuthUserInfo：', response);
      return response;
    } catch (error) {
      return errorHandler(error, '获取用户信息');
    }
  };

  /**
   * 查看用户是否上链(publicKey是否关联上某个用户)
   * @param publicKey
   * @returns {Promise.<*>}
   */
  getIsInChain = async () => {
    try {
      const response = await get(
        `${backendServerInvestor}/app/user/getUserInfo`
      );
      return response;
    } catch (err) {
      return errorHandler(err, '查看用户是否上链');
    }
  };

  /**
   * 包装数据，蚂蚁存证服务需要将数据打包成指定格式
   * 需要使用私钥
   * @param jsonData 当前需要请求的数据
   * @returns packData
   */
  getPackJson = async (msg, keysObj) => {
    try {
      const response = await jsonPost(
        'https://api.thundersdata.com/grpc/blockchain/crypt-service/sm2/Sign',
        //'https://api.test.thundersdata.com/grpc/blockchain/crypt-service/sm2/Sign',
        {
          ...keysObj,
          msg
        }
      );
      return response;
    } catch (err) {
      return errorHandler(err, '签名的数据');
    }
  };
}

const userStore = new UserStore();
export default userStore;



// WEBPACK FOOTER //
// ./src/stores/userStore/index.js